/**
 * Whether this browser holds an account's session, said before the first paint.
 *
 * Home is drawn differently for a first visit and for a signed-in visitor, and
 * the account is only known once the bundle has asked — on a slow connection,
 * seconds after the page was painted. Drawing neither until then moved the
 * whole screen when the answer came (#872). The session the account client
 * keeps in local storage is what that answer will almost always be, and it can
 * be read in the head, so the page is drawn as it says and the answer only
 * confirms it. A stored session that has since expired is the one case where
 * the answer still moves something.
 *
 * The client keys its session `sb-<project>-auth-token`; any project counts,
 * since a page is only ever served against one.
 */

/** Set on `<html>` where a session is stored. */
export const STORED_SESSION_ATTRIBUTE = "data-stored-session";

const SESSION_KEY = /^sb-.+-auth-token$/;

/**
 * The head script. It imports nothing and throws nothing: a browser that
 * refuses storage is drawn as a first visit, which is what it will turn out
 * to be.
 */
export function storedSessionScript(): string {
  return `(function(){try{var s=window.localStorage;for(var i=0;i<s.length;i++){var k=s.key(i);if(k&&${SESSION_KEY.toString()}.test(k)&&s.getItem(k)){document.documentElement.setAttribute(${JSON.stringify(STORED_SESSION_ATTRIBUTE)},"");return;}}}catch(e){}})();`;
}
